var map = {
	"./chicken-satay-lettuce-wraps/recipe.js": 3308,
	"./chili-garlic-spicy-noodles/recipe.js": 3474,
	"./dak-galbi/recipe.js": 46,
	"./detroit-style-pizza/recipe.js": 5749,
	"./eggplant-parmesan/recipe.js": 6265,
	"./lavash-triangles/recipe.js": 1022,
	"./pasta-amatriciana/recipe.js": 9373,
	"./samoas-cookies/recipe.js": 1184,
	"./springtime-saffron-pasta/recipe.js": 9924
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1912;